module.exports = __webpack_public_path__ + "static/media/open.8a75aa10.svg";